var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.119,
    height: 20.329,
    viewBox: "0 0 19.119 20.329",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "orderlist_2",
    "data-name": "orderlist 2",
    transform: "translate(-1724.34 -40.686)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_1959",
    "data-name": "Gruppe 1959",
    transform: "translate(0.549 -0.099)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_1220",
    "data-name": "Rechteck 1220",
    width: 9,
    height: 2,
    rx: 1,
    transform: "translate(1733.91 42.699)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vereinigungsmenge_8",
    "data-name": "Vereinigungsmenge 8",
    d: "M19856.031,16382.647l-1.414-1.415a1,1,0,1,1,1.414-1.416l.707.709,3.123-3.121a1,1,0,1,1,1.41,1.415l-3.828,3.828a1,1,0,0,1-1.412,0Z",
    transform: "translate(-18130.535 -16336.328)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_1964",
    "data-name": "Gruppe 1964",
    transform: "translate(0.549 7.73)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_1220-2",
    "data-name": "Rechteck 1220",
    width: 9,
    height: 2,
    rx: 1,
    transform: "translate(1733.91 41.697)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vereinigungsmenge_8-2",
    "data-name": "Vereinigungsmenge 8",
    d: "M19856.031,16382.647l-1.414-1.415a1,1,0,1,1,1.414-1.416l.707.709,3.123-3.121a1,1,0,1,1,1.41,1.415l-3.828,3.828a1,1,0,0,1-1.412,0Z",
    transform: "translate(-18130.535 -16337.328)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_1963",
    "data-name": "Gruppe 1963",
    transform: "translate(0 1.716)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_1223",
    "data-name": "Rechteck 1223",
    width: 9,
    height: 2,
    rx: 1,
    transform: "translate(1734.459 55.299)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rechteck_1255",
    "data-name": "Rechteck 1255",
    transform: "translate(1724.9 53.299)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6,
    rx: 2,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 4,
    height: 4,
    rx: 1,
    fill: "none"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart);
export default __webpack_public_path__ + "static/media/cart.d8547c27fee55c8fa48c9bba9d572628.svg";
export { ForwardRef as ReactComponent };